(() => {
  const requested = new URLSearchParams(window.location.search).get('bb_quantity');
  if (requested === null) return;

  const initialized = new WeakSet();

  const apply = (root) => {
    if (initialized.has(root)) return;
    const input = root.querySelector('.product-form__quantity .quantity__input');
    const note = root.querySelector('[data-bb-quantity-note]');
    if (!input || !note) return;
    initialized.add(root);

    input.value = /^[1-4]$/.test(requested) ? requested : '1';
    if (!input.checkValidity()) input.value = '1';
    note.hidden = input.value === requested;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const initAll = () => document.querySelectorAll('product-info').forEach(apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('product-info:loaded', (event) => apply(event.target));
  document.addEventListener('shopify:section:load', initAll);
})();
